import { WidgetProps } from '@rjsf/utils';
import { Autocomplete, TextField } from '@mui/material';
import { useParams } from 'react-router';
import { SyntheticEvent } from 'react';
import usePromptFolders from '../../api/prompts/usePromptFolders.ts';

const FolderPathWidget = (props: WidgetProps) => {
  const { value, onChange, schema, required, disabled, readonly, rawErrors, options } = props;
  const { projectId = '' } = useParams();
  const providedFolders = options?.folders as string[] | undefined;
  const { folders: fetchedFolders } = usePromptFolders(projectId || null, true, !providedFolders);
  const folders = providedFolders ?? fetchedFolders;

  const hasError = !!rawErrors?.length;

  const handleChange = (_: SyntheticEvent, newValue: string | null) => {
    onChange(newValue ? newValue : undefined);
  };

  const handleInputChange = (_: SyntheticEvent, newInputValue: string) => {
    onChange(newInputValue ? newInputValue : undefined);
  };

  return (
    <Autocomplete
      freeSolo
      options={folders}
      value={(value as string) ?? ''}
      onChange={handleChange}
      onInputChange={handleInputChange}
      disabled={disabled || readonly}
      renderInput={(params) => (
        <TextField {...params} label={schema.title ?? 'Folder'} required={required} error={hasError} />
      )}
      sx={(theme) => ({
        '& .MuiInputBase-root': {
          height: theme.spacing(5.5),
        },
      })}
    />
  );
};

export default FolderPathWidget;
